import React from "react";
import styled, { css } from "styled-components";

interface StyledWrapProps {
  selected?: boolean;
}

const Tab = ({
  children,
  ...rest
}: StyledWrapProps & React.ButtonHTMLAttributes<HTMLButtonElement>) => {
  return <StyledButton {...rest}>{children}</StyledButton>;
};

export default Tab;

export const TabGroup = ({
  children,
}: React.HTMLAttributes<HTMLDivElement>) => {
  return <TabGroupStyle>{children}</TabGroupStyle>;
};

/* 스타일 */
export const StyledButton = styled.button<StyledWrapProps>`
  flex: 1;
  background: none;
  padding: 0;
  padding-bottom: 0.6rem;
  box-sizing: border-box;
  border-bottom: 0.1rem solid transparent;
  text-align: center;

  ${({ theme: { color, typography, media } }) => css`
    color: ${color.text.secondary};

    ${typography.body1.medium}

    ${media.small} {
      ${typography.body3.regular}
    }
  `}

  ${({ theme: { color, fontWeight, media, typography }, selected }) =>
    selected &&
    css`
      color: ${color.text.highEmphasis};
      border-bottom-color: ${color.text.highEmphasis};

      font-weight: ${fontWeight.semibold};

      ${media.small} {
        ${typography.body3.semibold}
      }
    `};
`;

const TabGroupStyle = styled.div`
  display: flex;
  //gap: 3rem;
  width: 100%;
  margin-bottom: 2.4rem;
`;
